import React from 'react';
import { IconProps } from './types';

export const ReferralIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.5 15.4L8.5 12L9 11.15'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.5 15.4L15.5 12L15 11.15'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.5 18C21.5 19.3807 20.3807 20.5 19 20.5C17.6193 20.5 16.5 19.3807 16.5 18C16.5 16.6193 17.6193 15.5 19 15.5C20.3807 15.5 21.5 16.6193 21.5 18Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.5 18C7.5 19.3807 6.38071 20.5 5 20.5C3.61929 20.5 2.5 19.3807 2.5 18C2.5 16.6193 3.61929 15.5 5 15.5C6.38071 15.5 7.5 16.6193 7.5 18Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.7853 7.7143C15.7853 9.80509 14.0904 11.5 11.9996 11.5C9.90879 11.5 8.21387 9.80509 8.21387 7.7143C8.21387 5.62351 9.90879 3.92859 11.9996 3.92859C14.0904 3.92859 15.7853 5.62351 15.7853 7.7143Z'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
